import { app } from "modular-openscriptjs";

const h = app("h");

export default function BsIcon(icon, ...args) {
	return h.$(h.i({ class: `bi bi-${icon}` }, ...args));
}